var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"app-icon",style:(_vm.iconStyle),attrs:{"src":_vm.finalSrc,"alt":_vm.alt,"loading":_vm.lazy ? 'lazy' : 'eager',"decoding":_vm.decoding,"referrerpolicy":_vm.referrerPolicy},on:{"error":_vm.onError}})
}
var staticRenderFns = []

export { render, staticRenderFns }